import React from 'react';
import universal from 'react-universal-component';

import { Spinner } from 'app/design-system/components/Spinner';

import type { SidebarStakesProps } from './SidebarStakes';

import styles from './SidebarStakes.module.scss';

// ---

export default universal<SidebarStakesProps>(() => import('./SidebarStakes'), {
  loading: () => (
    <div className={styles.spinner}>
      <Spinner size={24} />
    </div>
  ),
});
